import mix from './mix';

export default (color: string, percent: number) => mix('#ffffff', color, percent);
